<div class="card">
  <p-toast />
  <div class="card" style="display: flex; justify-content:space-between; padding:0%; align-items:center; border: none; background-color: transparent;">
      <div><h4><strong style="font-size: large; margin-left:10px" style="color: black;">Reject Vendor List</strong></h4></div>
      <div class="grid">
          <p-button *ngIf="isListView" label="Card View" (click)="cardView()" class="mr-2"/>
          <p-button *ngIf="isCardView" label="List View" (click)="listView()" class="mr-2"/>
      <!-- <button pButton type="button"  style="height:10px; margin-top: -0px; background-color:black" label="Report"></button>     -->
      <p-button label="Report"  icon="pi pi-download" (click)="downloadExcel()"/>
      </div>
  </div>
  <hr>

  <div *ngIf="isCardView" class="grid">
      <!-- <div class="search-bar">
          <input type="text" [(ngModel)]="searchTerm" (input)="applySearch()" placeholder="Search rewards..." class="form-control">
        </div>     -->
      <div *ngFor="let vendor of vendorList">
          <div class="col">
              <app-vendor-detail-card  [vendor]="vendor"></app-vendor-detail-card>
          </div>
      </div>
      <!-- <p-paginator [rows]="rows"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="[5, 10, 20, 30]"
      (onPageChange)="onPageChange($event)">
      </p-paginator> -->
  </div>

  <!-- <div style="display: flex; justify-content:end; margin-bottom:20px;">
      <p-button
          pRipple
          severity="success"
          label="Approve"
          icon="pi pi-check"
          class="mr-2"
          (click)="deleteSelectedProducts()"
          [disabled]="!selectedVendor || !selectedVendor.length"
         />
  </div> -->
      <p-table *ngIf="isListView" [value]="vendorList" styleClass="p-datatable-striped p-datatable-gridlines"
      [showCurrentPageReport]="true" [tableStyle]="{ 'min-width': '150rem' }"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" >
      <ng-template pTemplate="header">
          <tr>
              <!-- <th style="width: 4rem">
                  <p-tableHeaderCheckbox />
              </th> -->
              <th class="bg-orange"></th>
              <th pSortableColumn="business_name" class="bg-orange">Name <p-sortIcon field="business_name"></p-sortIcon></th>
              <th pSortableColumn="vendor_code" class="bg-orange">Vendor Code <p-sortIcon field="vendor_code"></p-sortIcon></th>
              <th pSortableColumn="primary_address" class="bg-orange">Primary Address <p-sortIcon field="primary_address"></p-sortIcon></th>
              <!-- <th pSortableColumn="vendor_group">Vendor Group <p-sortIcon field="vendor_group"></p-sortIcon></th> -->
              <th pSortableColumn="city" class="bg-orange">City <p-sortIcon field="city"></p-sortIcon></th>
              <th pSortableColumn="state" class="bg-orange">State <p-sortIcon field="state"></p-sortIcon></th>
              <th pSortableColumn="country" class="bg-orange">Country <p-sortIcon field="country"></p-sortIcon></th>
              <th pSortableColumn="gstin" class="bg-orange">GSTIN Number <p-sortIcon field="gstin"></p-sortIcon></th>
              <th pSortableColumn="inventoryStatus" class="bg-orange">Status<p-sortIcon field="status"></p-sortIcon></th>
              <th pSortableColumn="creation_date" class="bg-orange">Creation Date<p-sortIcon field="creation_date"></p-sortIcon></th>
              <th pSortableColumn="is_black_list" class="bg-orange">Is Black List<p-sortIcon field="is_black_list"></p-sortIcon></th>
              <th pSortableColumn="is_legal_case" class="bg-orange">Is Legal Case<p-sortIcon field="is_legal_case"></p-sortIcon></th>
              <th pSortableColumn="black_list_remark" class="bg-orange">Black List Remark<p-sortIcon field="black_list_remark"></p-sortIcon></th>
              <th pSortableColumn="reject_reason" class="bg-orange">Reject Reason<p-sortIcon field="reject_reason"></p-sortIcon></th>
              <!-- <th pSortableColumn="changeRequest" class="bg-orange">Type<p-sortIcon field="Change Request"></p-sortIcon></th> -->
          </tr>
          <tr>
            <th></th>
            <th *ngFor="let col of cols">
              <ng-container *ngIf="col.field === 'creation_date'; else textInput">
                <input pInputText type="date" (change)="onInputChange($event, col.field)" placeholder="Select date..." />
              </ng-container>
              <ng-template #textInput>
                <ng-container *ngIf="col.field != 'state' && col.field != 'country'">
                  <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" />
                </ng-container>
              </ng-template>
                <!-- <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" /> -->
            </th>

        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-vendor>
          <tr>
              <!-- <td>
                  <p-tableCheckbox [value]="vendor" />
              </td> -->
              <td>
                  <button pButton type="button" icon="pi pi-eye" (click)="goToVendorDetails(vendor.get_user,vendor.status,vendor.business_name)" class="p-button-rounded" pTooltip="View Details"></button>
              </td>
              <td><strong>{{ vendor.business_name }}</strong></td>
              <td><strong>{{ vendor.vendor_code }}</strong></td>
              <td><strong>{{ vendor.address_title }}</strong></td>
              <!-- <td>{{ vendor.vendor_group }}</td> -->
              <td><strong>{{vendor.city}}</strong></td>
              <td><strong>{{getStateLabel(vendor.state,vendor.country)}}</strong></td>
              <td><strong>{{getcountries(vendor.country)}}</strong></td>
              <td><strong>{{vendor.gstn}}</strong></td>
              <td><strong>{{vendor.status}}</strong></td>
              <td><strong>{{vendor.creation_date | date:'dd.MM.yyyy'}}</strong></td>
              <td><strong>{{vendor.is_black_list}}</strong></td>
              <td><strong>{{vendor.is_legal_case}}</strong></td>
              <td><strong>{{vendor.black_list_remark}}</strong></td>
              <td><strong>{{vendor.reject_reason}}</strong></td>
              <!-- <td>
                  <p-button label="Change" icon="pi pi-user-edit" (click)="goToChangeRequest(vendor.vendor_code)"></p-button>
              </td> -->
          </tr>
      </ng-template>
  </p-table>
  <div>
    <p-paginator
    [rows]="limit"
    [first]="(currentPage - 1) * limit"
    [totalRecords]="totalRecords"
    (onPageChange)="onPageChange($event)"
    [rowsPerPageOptions]="[10,20,30,50,100]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
     />
</div>
</div>
